import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { DialogModal, FieldType, HPHButton, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";

const MasterFSPRejectReasonModal: React.FC = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const { searchStatus, currentSelectedRow, isShowRejectPad } = masterFSPState;
    const messageBarVM = useMessageBarVM();
    const onRejectClicked = () => {
        if (!currentSelectedRow.rejectReason) {
            messageBarVM.showError('Reject Reason is mandatory.');
            return;
        }
        masterFSPVM.onReject(searchStatus, currentSelectedRow, masterFSPState.searchCriteria);
        messageBarVM.showSuccess("Reject successfully.");
    }

    const memoRejectReason = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "395px", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow.rejectReason || ''}
                fieldValue={currentSelectedRow.rejectReason}
                fieldLabel={MasterFSPMaintenanceConstant.REJECT_REASON}
                isSaveClicked={false}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'rejectReason'}
                maxLength={200}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => masterFSPVM.onRejectReasonTextAreaChange(fieldValue && fieldValue.toString())}
                requiredFieldList={['rejectReason']} />
        </div>
        , [currentSelectedRow.rejectReason, masterFSPVM])



    return <><DialogModal style={{ minWidth: '650px', minHeight: '650px' }}
        appendTo='self'
        showButton={false}
        visible={isShowRejectPad}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">Reject Reason</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={masterFSPVM.cancelRejectReasonModal} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className="im-charge-data-search-confirm-modal-content">

                <CriteriaItemContainer>
                    {memoRejectReason}
                </CriteriaItemContainer>

            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                <HPHButton disabled={currentSelectedRow.rejectReason?.length === 0} label={'Reject'} size={'Small'} theme={'Primary'} onClick={onRejectClicked} />
            </div>
        }
    /></>;
};

export default memo(MasterFSPRejectReasonModal);